export const isCommunityFeatureEnabled = (env = process.env.NEXT_PUBLIC_ENV) =>
  ['dev', 'develop', 'staging', 'production'].includes(env ?? '');

export const COMMUNITY_FEATURE_ENABLED = isCommunityFeatureEnabled();
